import * as React from "react"
import { SwanProvider, useBrowserClasses, ScreenClassProvider } from "@vp/swan"

export const SwanConfiguration = ({ tenant, locale, children }) => {
  useBrowserClasses(true)
  return (
    <SwanProvider swanLocale={locale} swanTenant={tenant}>
      <ScreenClassProvider>{children}</ScreenClassProvider>
    </SwanProvider>
  )
}
